import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  Wrap,
  WrapItem,
  useToast,
} from '@chakra-ui/react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import SingleVariationField from './SingleVariationField';
import EditSingleVariationField from './EditSingleVariationField';
import { useMsal } from '@azure/msal-react';
interface EditVariationModalProps {
  isOpen: boolean;
  onClose: () => void;
  variationData: any;
  setVariationData: any;
  documentID: any;
  count: number;
  setCount: any;
}

interface currentEditModal {
  variationid: number;
  documentid: number;
  name: string;
  description: string;
  fields: any;
}

function EditVariationModal({
  isOpen,
  onClose,
  variationData,
  setVariationData,
  documentID,
  count,
  setCount,
}: EditVariationModalProps) {
  let toast = useToast();

  const [dropDownOptions, setDropDownOptions] = useState();

  useEffect(() => {
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;

    // Function to fetch the token and then the forms
    let fetchForms = async () => {
      try {
        let tokenResponse = await axios.get(tokenUrl);

        if (tokenResponse.data.success) {
          let formsResponse = await axios.get(
            baseurl + '/Appeal/get_available_fields',
            {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + tokenResponse.data.token,
              },
            }
          );
          if (formsResponse.status === 200) {
            setDropDownOptions(formsResponse.data);
          } else {
            throw new Error(
              `Failed to fetch forms: ${
                formsResponse.data.message || 'Unknown error'
              }`
            );
          }
        } else {
          throw new Error(
            `Failed to retrieve auth token: ${
              tokenResponse.data.message || 'Unknown error'
            }`
          );
        }
      } catch (error: any) {
        console.error(
          'Error fetching forms:',
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchForms();
  }, [variationData]);

  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  const updateVariation = async () => {
    const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_TOKEN_URL_PAYER_FORM as string;
    // Function to fetch the token and then the forms
    try {
      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const formsResponse = await axios.post(
          baseurl + '/App/api/save_variation?username=' + userid,
          variationData,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + tokenResponse.data.token,
            },
          }
        );
        if (formsResponse.data.success) {
          setCount(count + 1);
          toast({
            title: 'Success',
            position: 'top',
            description: 'Variation Successfully Edited!',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        } else {
          throw new Error('Failed to fetch forms');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error fetching forms:', error);
    }
  };

  const handleChangeDefaultValue = (fieldId: number, value: string) => {
    const updatedFields = variationData.fields.map((field: any) => {
      if (field.fieldid === fieldId) {
        return { ...field, defaultvalue: `FIELD:${value}` };
      }
      return field;
    });

    setVariationData((prevState: any) => ({
      ...prevState,
      fields: updatedFields,
    }));
  };

  const handleSubmit = (event: any) => {
    event.preventDefault(); // Prevent the default form submission behavior
    updateVariation();
    onClose();
  };

  return (
    <>
      {variationData && (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl">
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader textAlign="center">Edit Variation</ModalHeader>
              <ModalCloseButton color="white" bg=" #002677" />
              <ModalBody>
                <Flex textAlign="center" flexDir="column">
                  <FormControl width="500px" isRequired>
                    <FormLabel>Name:</FormLabel>
                    <Input
                      type="text"
                      placeholder="Insert Name"
                      value={variationData.name}
                      onChange={event => {
                        const newName = event.target.value;
                        setVariationData((prevFormData: any) => ({
                          ...prevFormData,
                          name: newName,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl width="500px" isRequired>
                    <FormLabel>Description:</FormLabel>
                    <Input
                      type="text"
                      placeholder="Insert Description"
                      value={variationData.description}
                      onChange={event => {
                        const newDesc = event.target.value;
                        setVariationData((prevFormData: any) => ({
                          ...prevFormData,
                          description: newDesc,
                        }));
                      }}
                    />
                  </FormControl>
                  <Wrap mt="20px">
                    {variationData && variationData.fields
                      ? variationData.fields.map((data: any) => (
                          <WrapItem key={data.fieldid}>
                            <Box width="300px">
                              <EditSingleVariationField
                                dropDownOptions={dropDownOptions}
                                fieldData={data}
                                handleChangeDefaultValue={
                                  handleChangeDefaultValue
                                }
                              />
                            </Box>
                          </WrapItem>
                        ))
                      : ''}
                  </Wrap>
                </Flex>
              </ModalBody>
              <ModalFooter>
                <Button
                  bg="#002677"
                  textColor="white"
                  mr={3}
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancel
                </Button>
                <Spacer />
                <Button
                  variant="ghost"
                  bg="#002677"
                  textColor="white"
                  type="submit"
                >
                  Save Variation
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

export default EditVariationModal;
